import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.team.IFetchTeamMembers) {
    yield put({
        type: "com.sage.actions.teams.ISetTeamMembersStatus",
        status: "loading",
    } as sage.actions.team.ISetTeamMembersStatus);
    try {
        const response = yield post("/team-users-member", {
            team_id: action.teamId,
        });
        if (response.data != null) {
            yield put({
                type: "com.sage.actions.teams.ISetTeamMembersTeams",
                teamId: action.teamId,
                users: response.data,
            } as sage.actions.team.ISetTeamMembersTeams);
            yield put({
                type: "com.sage.actions.teams.ISetTeamMembersStatus",
                status: "none",
            } as sage.actions.team.ISetTeamMembersStatus);
        } else {
            yield put({
                type: "com.sage.actions.teams.ISetTeamMembersStatus",
                status: "error",
            } as sage.actions.team.ISetTeamMembersStatus);
        }
    } catch (e) {
        yield put({
            type: "com.sage.actions.teams.ISetTeamMembersStatus",
            status: "error",
        } as sage.actions.team.ISetTeamMembersStatus);
        yield handleNetworkError(e);
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.team.IFetchTeamMembers", execute);
}
